import * as React from 'react';
import Button from '@telia-front/button';
import CompareMenu from '@telia-front/compare-menu';
import Grid, { GridColumn } from '@telia-front/grid';
import Skeleton, { SkeletonItem } from '@telia-front/skeleton';
const BEM = (props) => {
    const { variant = 'light', className } = props;
    const classArray = ['sort-bar', `sort-bar--${variant}`];
    if (className) {
        classArray.push(className);
    }
    return classArray.join(' ');
};
const SortBar = (props) => {
    return (React.createElement("div", { className: BEM(props) },
        React.createElement(SortBarFilter, Object.assign({}, props)),
        props.compare && React.createElement(CompareMenu, Object.assign({}, props.compare, ('skeleton' in props ? { skeleton: props.skeleton } : {}), { className: "sort-bar__compare" }))));
};
const SortBarFilter = (props) => {
    if ('skeleton' in props) {
        const { skeleton } = props;
        return (React.createElement(Skeleton, { label: skeleton.label },
            React.createElement(SkeletonItem, { className: `${BEM(props)} sort-bar__filter`, height: "42px", width: "100%" })));
    }
    return (React.createElement("div", { className: "sort-bar__filter" },
        (props.listViewButton || props.gridViewButton) && React.createElement(SortBarSwitch, { listViewButton: props.listViewButton, gridViewButton: props.gridViewButton }),
        props.children && React.createElement("div", { className: "sort-bar__content" }, props.children)));
};
const SortBarSwitch = (props) => {
    return (React.createElement(Grid, { gutter: "small", className: "sort-bar__switch", noWrap: true },
        props.listViewButton && (React.createElement(GridColumn, { width: ['xs'] },
            React.createElement(Button, Object.assign({}, props.listViewButton, { icon: "#list-view", iconSize: "xs", link: true, type: "text-color", verticalAlign: "bottom" })))),
        props.gridViewButton && (React.createElement(GridColumn, { width: ['xs'] },
            React.createElement(Button, Object.assign({}, props.gridViewButton, { icon: "#grid-view", iconSize: "xs", link: true, type: "text-color", verticalAlign: "bottom" }))))));
};
export default SortBar;
